import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import {
    IMenuCollection,
    ISelectedMenuLinkData,
    INavRailItems,
} from '@uilab/core-angular';
import { MenusService } from 'src/app/services/menus/menus.service';
import { PageService } from 'src/app/services/page/page.service';
import { PreferencesService } from 'src/app/services/preferences/preferences.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';

@Component({
    selector: 'app-navrail',
    templateUrl: './navrail.component.html',
    styleUrls: ['./navrail.component.scss'],
    standalone: false,
})
export class NavrailComponent implements OnInit, OnDestroy {
    private _localStorageSubscription!: Subscription;
    public busy: boolean = false;
    private _isCollapsed: boolean = false;
    private inited: boolean = false;
    private home: INavRailItems = {
        name: 'Home',
        icon: 'navigation--home',
        linkData: {
            href: 'build/',
            data: '',
        },
        type: 'link',
    };

    private landing: INavRailItems = {
        name: 'ADS landing page',
        icon: 'navigation--back',
        linkData: {
            href: '/',
            data: '/',
        },
        type: 'link',
    };

    private divider: any = {
        type: 'divider',
        name: '',
    };
    activeRoute = ['/'];
    navRail: IMenuCollection[] = [this.home, this.divider];

    constructor(
        public pageService: PageService,
        public preferences: PreferencesService,
        private router: Router,
        private menuService: MenusService,
    ) {
        this._isCollapsed = this.preferences.getNavRailState();

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.setActiveRoute();
            }
        });

        this.busy = true;
        this.menuService.getNavigation();
    }

    ngOnInit(): void {
        this.menuService.menus$
            .pipe(
                filter((data) => !!data?.length),
                take(1),
            )
            .subscribe({
                next: (data) => {
                    this.busy = false;

                    const menus = data;
                    this.setNavRail(menus);

                    if (this.inited) {
                        this.setActiveRoute();
                    }
                },
            });

        if (!this.busy) {
            this.setActiveRoute();
        }
        this.inited = true;
        this.localStorageSubscription = this.preferences
            .watchStorage()
            .subscribe((value) => {
                this.isCollapsed = value;
            });
    }

    setActiveRoute(): void {
        let rte = '';
        let pathParts = window.location.pathname.split('/');
        if (pathParts[2]) {
            rte = `/${pathParts[2]}`;
            let newrte = rte.replace(`${environment.base}`, '');
            if (newrte.endsWith('/')) {
                newrte = newrte.slice(0, -1);
            }
            let item = this.navRail.find((i) => {
                return i.linkData?.href == newrte;
            });
            if (item) {
                rte = newrte;
            } else {
                rte = `${environment.base}${newrte}/`;
            }
        } else {
            rte = `${environment.base}/`;
        }

        let secondaryLevel = ``;

        if (pathParts?.[3]) {
            secondaryLevel = `${pathParts[1]}/${pathParts[2]}/${pathParts?.[3]}/`;
        }

        if (!pathParts?.[3] && pathParts?.[2]) {
            secondaryLevel = `${pathParts[1]}/${pathParts[2]}/`;
        }

        this.activeRoute = [rte, ...[secondaryLevel]];
    }

    navTo(dest: ISelectedMenuLinkData): void {
        const rte = dest.linkData.href;
        this.router.navigate([rte]);
        this.preferences.setNavRailOpen(false);
    }

    collapsed(value: any): void {
        this.preferences.setNavRailOpen(value);
    }

    setNavRail(menus: INavRailItems[]): void {
        // if (environment.version === 'preview') {
        menus.forEach((it) => this.navRail.push(it));
        this.navRail.push(this.divider);
        this.navRail.push(this.landing);
        // } else {
        //   this.navRail = menus;
        // }
    }

    get localStorageSubscription(): Subscription {
        return this._localStorageSubscription;
    }

    set localStorageSubscription(value: Subscription) {
        this._localStorageSubscription = value;
    }

    get isCollapsed(): boolean {
        return this._isCollapsed;
    }

    set isCollapsed(value: boolean) {
        this._isCollapsed = value;
    }

    ngOnDestroy() {
        if (typeof this.localStorageSubscription !== 'undefined') {
            this.localStorageSubscription.unsubscribe();
        }
    }
}
